module.exports = require("next-routes");